import { provideZoneChangeDetection, isDevMode } from '@angular/core';
/// <reference types="@angular/localize" />

/* reflect-metadata deve essere importato prima di tutto, soprattutto prima di APP_INITIALIZER
   che viene chiamato dall'import di appConfig */
import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Big } from 'big.js';
import { CURRENCY_DECIMALS, CURRENCY_ROUNDING } from '@h5s/util-currency';
import { provideServiceWorker } from '@angular/service-worker';

Big.RM = CURRENCY_ROUNDING;
Big.DP = CURRENCY_DECIMALS;

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error(err));
